import React from 'react';
import Slider from 'react-slick';

function SimpleSlider({ images }) {
  const settings = {
    dots: false,
    infinite: images?.length > 1,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: images?.length > 1,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          infinite: images?.length > 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: images?.length > 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>
        {images?.map((image, index) => (
          <div key={index} className="px-2">
            <img
              src={image?.url}
              alt={`Slide ${index}`}
              className="rounded-md"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default SimpleSlider;
